export default {
  shares: {
    title: 'أسهم المستخدم',
    direct: 'الأسهم المباشرة',
    indirect: 'الأسهم غير المباشرة',
    empty: 'لا توجد أسهم',
    emptyIndirect: 'لا توجد أسهم غير مباشرة',
    userOwnership: 'ملكيتك',
    indirectOwnership: 'ملكيتك غير المباشرة',
    intermediaryCompany: 'شركة وسيطة',
    loadError: 'تعذر تحميل أسهمك',
    graphError: 'تعذر عرض مخطط الملكية',
    retry: 'إعادة المحاولة',
  },
  form: {
    profileManagement: 'إدارة الملف الشخصي',
    myInfo: 'معلوماتي',
    myInfoOverview: 'نظرة عامة على معلوماتي',
    profilePic: 'صورة الملف الشخصي',
    legalNameTitle: 'الاسم القانوني واللقب',
    designation: 'التسمية الوظيفية',
    nationalID: 'رقم الهوية',
    nationalIDLength: 'يجب أن يتكون رقم الهوية من 10 أحرف',
    phoneNumber: 'رقم الهاتف',
    verified: 'تم التحقق',
    verify: 'تحقق',
    emailAddress: 'عنوان البريد الإلكتروني',
    address: 'العنوان',
    zipCode: 'الرمز البريدي',
    iban: 'ايبان',
    bankName: 'اسم البنك',
    about: 'حول',
    updateMyInfo: 'تحديث معلوماتي',
    agree: 'أوافق',
    disagree: 'لا أوافق',
    agreementTitle: 'اتفاقية المستخدم',
    agreementContent:
      'من خلال حفظ ملفك الشخصي، فإنك تؤكد أن جميع المعلومات التي تقدمها صحيحة ودقيقة وتقع تحت مسؤوليتك الكاملة. رأس مال غير مسؤولة عن أي معلومات غير صحيحة أو كاذبة أو غير مكتملة تقدمها.',
  },
};
